<template>
  <b-row>
    <b-col>
      <!-- Alinha campos e botões na mesma linha no md+ -->
      <b-row class="align-items-end">
        <!-- Data Inicial -->
        <b-col md="4" sm="12">
          <b-form-group label="Data Inicial" label-for="from-date">
            <b-form-datepicker
              id="from-date"
              v-model="form.fromDate"
              placeholder="Selecione uma data"
              :date-format-options="{
                year: 'numeric',
                month: '2-digit',
                day: '2-digit'
              }"
              locale="pt-BR"
            />
          </b-form-group>
        </b-col>

        <!-- Data Final -->
        <b-col md="4" sm="12">
          <b-form-group label="Data Final" label-for="to-date">
            <b-form-datepicker
              id="to-date"
              v-model="form.toDate"
              placeholder="Selecione uma data"
              :date-format-options="{
                year: 'numeric',
                month: '2-digit',
                day: '2-digit'
              }"
              locale="pt-BR"
            />
          </b-form-group>
        </b-col>

        <!-- Botões -->
        <b-col
          md="4"
          sm="12"
          class="mt-2 mt-md-0 d-flex justify-content-md-end"
        >
          <div class="action-buttons d-flex flex-column flex-md-row w-100">
            <b-button
              variant="secondary"
              class="mb-2 mb-md-0 mr-0 mr-md-2 w-100 w-md-auto"
              @click="handleClear"
            >
              <span class="fas fa-times mr-2" />Limpar
            </b-button>

            <b-button
              variant="primary"
              class="w-100 w-md-auto"
              @click="handleFilter"
            >
              <span class="fas fa-filter mr-2" />Filtrar
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: 'PeriodReportFilter',
  props: {
    value: {
      type: Object,
      default: () => ({ fromDate: null, toDate: null, groupBy: 'day' })
    }
  },
  computed: {
    form: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit('input', v)
      }
    }
  },
  methods: {
    handleFilter() {
      this.$emit('filter')
    },
    handleClear() {
      this.form = { fromDate: null, toDate: null, groupBy: 'day' }
      this.$emit('filter')
    }
  }
}
</script>

<style scoped>
/* Espaçamento horizontal entre botões quando em linha (md+) */
@media (min-width: 768px) {
  .action-buttons > .btn + .btn {
    margin-left: 0.5rem;
  }
}

/* No mobile: botões ocupam largura total (já aplicado via classes), garante espaçamento vertical */
@media (max-width: 767.98px) {
  .action-buttons > .btn {
    width: 100%;
  }
}
</style>
